var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingIcon = function SvgSettingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 26.25a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22.54v-3.08a3.335 3.335 0 0 1 3.325-3.325c3.167 0 4.462-2.24 2.87-4.987a3.323 3.323 0 0 1 1.225-4.532l3.027-1.733c1.383-.822 3.168-.332 3.99 1.05l.193.333c1.575 2.747 4.165 2.747 5.758 0l.192-.333c.823-1.382 2.608-1.872 3.99-1.05l3.027 1.732a3.323 3.323 0 0 1 1.225 4.533c-1.592 2.748-.297 4.988 2.87 4.988a3.335 3.335 0 0 1 3.325 3.325v3.08a3.335 3.335 0 0 1-3.325 3.325c-3.167 0-4.462 2.24-2.87 4.987a3.32 3.32 0 0 1-1.225 4.532l-3.027 1.733c-1.383.822-3.168.332-3.99-1.05l-.192-.332c-1.576-2.748-4.166-2.748-5.758 0l-.192.332c-.823 1.383-2.608 1.873-3.99 1.05l-3.028-1.733a3.323 3.323 0 0 1-1.225-4.532c1.592-2.748.297-4.988-2.87-4.988A3.335 3.335 0 0 1 4 22.541Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSettingIcon;